// removed by extract-text-webpack-plugin
module.exports = {"messageWrapper":"_3tTW1fazfrco30zpnHSRLc","title":"_2UqroVh5HVzKTwPofZfBP1","text":"_3EX_wtn8BDInMv2Fz-U8VA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentFailMessage/PaymentFailMessage.scss
// module id = 1685
// module chunks = 0